import React from 'react';
import { DialogManager } from '../fasades/dialogmanager';
import './styles.css';

export type SaveInfo = {
    name : string;
};

type SaveDialogProps = {
    name      : string;
    saveAsNew : boolean;

    onCancel?  : () => void;
    onSave?    : (name : string) => void;
};

export class SaveDialog extends React.Component<SaveDialogProps, SaveInfo> {
    dialogRef = React.createRef<HTMLDialogElement>();

    constructor(props: SaveDialogProps) {
        super(props);
        this.state = {
            name : props.name
        };
    }

    componentDidMount() {
        // Show the dialog when the component mounts
        if (this.dialogRef.current) {
          this.dialogRef.current.showModal();
        }
    }

    handleCancel()
    {
        if (this.props.onCancel) {
            this.props.onCancel();
        }

        this.handleClose();
    }

    handleClose() 
    {
        if (this.dialogRef.current) {
            this.dialogRef.current.close();
        }
        DialogManager.close();
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)
    {
        if (e.target.name === "name") {
            this.setState({ name : e.target.value });
        }
    }

    handleSave() 
    {
        if (this.props.onSave) {
            this.props.onSave(this.state.name);
        }

        this.handleClose();
    };

    render() {
        return (
          <dialog ref={this.dialogRef} className="dialogStyle">
            <h2 style={{marginTop: 0}}>Save Settings</h2>
            <form method="dialog" onSubmit={e => e.preventDefault()}>
              <label className="labelStyle" htmlFor="name">Save (name)</label>
              <input
                className="inputStyle"
                id="name"
                name="name"
                type="text"
                value={this.state.name}
                onChange={(e) => this.handleChange(e) }
                placeholder="Enter a name"
                required
              />

              <div className="buttonRowStyle">
                <button type="button" className="buttonStyle cancelStyle" onClick={() => this.handleCancel()}>
                  Cancel
                </button>

                <button type="button" className="buttonStyle saveStyle" onClick={() => this.handleSave()}>
                    {this.props.saveAsNew ? "Save As New" : "Save"}
                </button>
              </div>
            </form>
          </dialog>
        );
      }

    static showSaveDialog(name : string, saveAsNew : boolean) : Promise<string> 
    {
        return new Promise((resolve, reject) => {
            DialogManager.open(
                <SaveDialog
                    name={name}
                    saveAsNew={saveAsNew}
                    onSave={(name : string) => resolve(name)}
                    onCancel={() => reject(new Error("Cancelled!"))}/>
            );
        });
    }
}

